import Lesson from './Lesson'

export default class Chapter {
  constructor (data) {
    if (!data || !data.id) throw new Error('Wrong Chapter data')

    this.id = data.id
    this.label = data.chapter_name ?? ''

    this.lessons = data.lessons ? data.lessons.map(l => new Lesson(l)) : []
  }
}
